
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';

  export default defineComponent({
    name: 'exchange-rate-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('exchangeRateListing'), [
          translate('assets'),
        ]);
        loading.value = true;
        await store.dispatch(Actions.GET_CURRENCIES);
        loading.value = false;
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_CURRENCIES_STORE);
      });

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('code'),
          key: 'code',
          sortable: true,
        },
        {
          name: translate('exchangeRate'),
          key: 'exchangeRate',
          sortable: true,
        },
        {
          name: translate('isPrimary'),
          key: 'isPrimary',
          sortable: false,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const deleteExchangeRate = async (currency) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_CURRENCY, currency.id);
          await store.dispatch(Actions.GET_CURRENCIES);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          }
        }
      };

      const editExchangeRate = (id) => {
        router.push({ name: 'exchange-rate-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_CURRENCY_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_CURRENCIES);

        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.currenciesList),
        tableHeader,
        deleteExchangeRate,
        translate,
        totalItems: computed(() => store.getters.currenciesListCount),
        pageChanged,
        goTo,
        editExchangeRate,
        loading,
        can,
      };
    },
  });
